import AnnualDataQualityMeasurementIntegrity from "./AnnualDataQualityMeasurementIntegrity";

const AnnualWaitTimeDistributionPeakWait = (props) => (
  <AnnualDataQualityMeasurementIntegrity
    {...props}
    title="Annual Wait-Time Distribution and Peak-Wait"
    description="Annual wait distribution envelope showing bands, percentiles, peak waits, and confidence caveats where raw samples are unavailable."
    emptyTableText="No annual wait distribution tables were supplied."
  />
);

export default AnnualWaitTimeDistributionPeakWait;
